export default __webpack_public_path__ + "static/media/insideout-logo.9d5a0521.png";